import React, { useEffect, useState,useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  Tooltip
} from "@material-ui/core";
import { createMuiTheme, withStyles } from "@material-ui/core/styles";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import { formatDate, parseDate } from "react-day-picker/moment";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ThemeProvider } from "@material-ui/core/styles";
// import {useDropzone} from 'react-dropzone';
import {validateBirthday,fileValidation} from './Util.js';

export const dictionary = [
 
  "One",
  "Two",
  "Three",
  "Four",
  "Five"
];


export const IsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
};

export const ClickToPhone = props => {
  const m = IsMobile();
  return props.phone != null && props.phone !== "" ? (
    <span>
      {m ? (
        <a href={"tel:" + props.phone}>
          <i className="icon-tiny fa fa-phone extra-color-3" />
        </a>
      ) : (
        <i className="icon-tiny fa fa-phone extra-color-3" />
      )}
      {m ? (
        <a href={"sms:" + props.phone}>
          <i className="icon-tiny fa fa-comment-o extra-color-3" />
        </a>
      ) : null}
      {props.phone}
    </span>
  ) : null;
};

export const fetchNetworkingStagesStatus = async ({
  wordpressId,
  callback,
  nonce
}) => {
  await fetch("/wp-json/prism/v1/networking-stages-status/" + wordpressId, {
    headers: { "X-WP-Nonce": nonce }
  })
    .then(response => response.json())
    .then(result => callback(result[0]));
};

const EditableRow = ({ field, label, placeholder, value, callback, isMandatory }) => {
  const required = isMandatory != null ? true : false;
  const placeHolder = placeholder != null ? placeholder : "";
  return (
    <div className="dataRow">
      <div className="dataRowLabel">
        <strong>{label}{required == true ? <span className="redColor"> *</span> : ""}</strong>
      </div>
      <div className="dataRowField">
        <input
          name={field}
          value={value[field] != null ? value[field] : ""}
          placeHolder={placeHolder}
          onChange={v => callback({ ...value, [field]: v.target.value })}
          required = {required}
        />
      </div>
    </div>
  );
};

const EditType = ({ field, value, callback }) => {
  return (
    <select
      name={field + "Type"}
      value={value != null ? value[field + "Type"] : ""}
      onChange={v => callback({ ...value, [field + "Type"]: v.target.value })}
      style={{ width: "auto" }}
    >
      <option />
      {field.indexOf("phone") > -1 || field.indexOf("email") > -1 ? (
        <option value="Main">Main</option>
      ) : null}
      {field.indexOf("phone") > -1 ? (
        <option value="Mobile">Mobile</option>
      ) : null}
      <option value="Home">Home</option>
      <option value="Work">Work</option>
      <option value="Other">Other</option>
    </select>
  );
};

const EditMonth = ({ field, value, callback }) => {
  return (
    <select
    id="MonthDrop"
      name={field + "Month"}
      value={value != null ? value[field + "Month"] : ""}
      onChange={v => callback({ ...value, [field + "Month"]: v.target.value })}
      style={{ width: "auto" }}
    >
     <option value="00" selected>Select a Month </option>
      <option value="01" >January</option>
      <option value="02">February</option>
      <option value="03">March</option>
      <option value="04">April</option>
      <option value="05">May</option>
      <option value="06">June</option>
      <option value="07">July</option>
      <option value="08">August</option>
      <option value="09">September</option>
      <option value="10">October</option>
      <option value="11">November</option>
      <option value="12">December</option>
    </select>
  );
};

const EditableRowWithType = ({ field, label, value, callback }) => {
  return (
    <div className="dataRow">
      <div className="dataRowLabel">
        <strong>{label}</strong>
      </div>
      <div className="dataRowField">
        <input
          name={field.includes("address") ? field + "Street" : field}
          value={value[field] != null ? value[field] : ""}
          onChange={v => callback({ ...value, [field]: v.target.value })}
          //style={value[field] == "Missing"?{color:"red"}:{}}
        />
        <EditType field={field} value={value} callback={callback} />
      </div>
    </div>
  );
};

const EditableRowWithDate = ({ field, label, value, callback }) => {
  return (
    <div className="dataRow">
      <div className="dataRowLabel">
        <strong>{label}</strong>
      </div>  
      <div className="dataRowField">
      <EditMonth field={field} value={value} callback={callback} />
        <input
         id="daytext"
          name={field + "Day"}
          value={value[field] != null ? value[field + "Day"] : ""}
          placeholder = "DD"
          onChange={v => callback({ ...value, [field]: v.target.value })}
          style={{ width: "32px",margin: "8px" }}
          maxlength="2"
        />
        <input
          id="yeartext"
          name={field + "Year"}
          value={value[field] != null ? value[field + "Year"] : ""}
          placeholder = "YYYY"
          onChange={v => callback({ ...value, [field]: v.target.value })}
          style={{ width: "50px" }}
          maxlength="4"
        />
        <span> year optional</span>
      </div>
    </div>
  );
};



const EditableRowAddress = ({ field, label, value, callback }) => {
  return (
    <div>
      <EditableRowWithType
        field={field}
        label={label}
        value={value}
        callback={callback}
      />
      <EditableRow
        field={field + "City"}
        label="City"
        value={value}
        callback={callback}
      />
      <EditableRow
        field={field + "State"}
        label="State"
        value={value}
        callback={callback}
      />
      <EditableRow
        field={field + "Country"}
        label="Country"
        value={value}
        callback={callback}
      />
      <EditableRow
        field={field + "Zip"}
        label="Zip"
        value={value}
        callback={callback}
      />
    </div>
  );
};

export const AddContactWidget = ({ open, setOpen }) => {
  const [values, setValues] = useState([]);
 
  // function validateBirthday(event)
  // {
       
  //   var Month = document.getElementById("MonthDrop").value;
  //   var Day = document.getElementById("daytext").value;
  //   var Year = document.getElementById("yeartext").value;
  //   var currentYear = new Date().getFullYear();
  //   Year = Year=="" && Month != "00"? currentYear : Year;
  //   var days31 = ["01","03","05","07","08","10","12"].includes(Month);
  //   var days30 = ["04","06","09","11"].includes(Month);
  //   if(Month!="00")
  //   {
  //     if(Day =="")
  //     {
  //     alert("Please Enter Day");
  //     event.preventDefault();
  //     return false;
  //     }
  //   }
  //   if(Day !=""){
  //     if(Month=="00")
  //   {
  //     alert("Please select Month");
  //     event.preventDefault();
  //     return false;
  //   }  
  //   }
  //   if(Year !=""){
  //     if(Month=="00")
  //   {
  //     alert("Please select Month");
  //     event.preventDefault();
  //     return false;
  //   }
  //   if(Day =="")
  //   {
  //   alert("Please Enter Day");
  //   event.preventDefault();
  //   return false;
  //   }
  //   }
  //   if(days31==true)
  //   {
  //     if(Day > 31 || Day <= 0){
  //     alert("Please Enter Valid Day");
  //     event.preventDefault();
  //     return false;
  //     }
  //   }
  //   if(days30 == true)
  //   {
  //     if(Day > 30 || Day <=0){
  //     alert("Please Enter Valid Day");
  //     event.preventDefault();
  //     return false;
  //     }
  //   }
  //   if(Month == "02")
  //   {
  //     if ((!(Year % 4) && Year % 100) || !(Year % 400))
  //      {
  //       if(Day > 29|| Day <=0)
  //       {
  //         alert("Please Enter Valid Day");
  //         event.preventDefault();
  //         return false;
  //       }
  //     }
  //     else if(Day > 28 || Day <=0)
  //     {
  //       alert("Please Enter Valid Day");
  //         event.preventDefault();
  //         return false;
  //     }
  //   }
  //   if(Year > currentYear)
  //   {
  //     alert("Please future entry not allowed");
  //     event.preventDefault();
  //     return false;
  //   }
  //   return true;
  // }
 


const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};
const maxLength = 20;

function nameLengthValidator(file) {
  if (file.name.length > maxLength) {
    return {
      code: "name-too-large",
      message: `Name is larger than ${maxLength} characters`
    };
  }

  return null
}
const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};


// function StyledDropzone(props) {
//   const [files, setFiles] = useState([]);

//   const {
//     getRootProps,
//     getInputProps,
//     isDragActive,
//     isDragAccept,
//     isDragReject
//   } = useDropzone({
//     accept: 'image/*',
//     maxFiles:1,
//     validator: nameLengthValidator,
//     onDrop: acceptedFiles => {
//       setFiles(acceptedFiles.map(file => Object.assign(file, {
//         preview: URL.createObjectURL(file)
//       })));
//     }
//   });

//   const thumbs = files.map(file => (
//     <div style={thumb} key={file.name}>
//       <div style={thumbInner}>
//         <img
//           src={file.preview}
//           style={img}
//         />
//       </div>
//     </div>
//   ));
 
//   const style = useMemo(() => ({
//     ...baseStyle,
//     ...(isDragActive ? activeStyle : {}),
//     ...(isDragAccept ? acceptStyle : {}),
//     ...(isDragReject ? rejectStyle : {})
//   }), [
//     isDragActive,
//     isDragReject,
//     isDragAccept
//   ]);
//   useEffect(() => () => {
//     // Make sure to revoke the data uris to avoid memory leaks
//     files.forEach(file => URL.revokeObjectURL(file.preview));
//   }, [files]);
//   return (
//     <section className="container">
//       <div {...getRootProps({className: 'dropzone'})}>
//         <input name="pictureRef" {...getInputProps()} />
//         <p>Drag 'n' drop some files here, or click to select files</p>
//       </div>
//       <aside style={thumbsContainer}>
//         {thumbs}
//       </aside>
//     </section>
   
//   );
// }


  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      style={{ zIndex: 26000 }}
      fullWidth={true}
      maxWidth="sm"
    >
      <form
        action="/wp-admin/admin-post.php"
        method="POST"
        enctype="multipart/form-data"
        onSubmit={(event)=>{
          validateBirthday(event);
          }}
        onInput ={(event)=>{fileValidation(event);}}
      >
        <input type="hidden" name="action" value="request_add_contact" />
        <input type="hidden" name="importSource" value="PRISM" />
        <DialogTitle>Add Contact</DialogTitle>
        <DialogContent dividers>
           <Image/>
           <hr />
          <EditableRow
            field="firstName"
            label= "First Name"
            value={values}
            callback={setValues}
            isMandatory = "Yes"
           
          />
          <EditableRow
            field="lastName"
            label="Last Name"
            value={values}
            callback={setValues}
            isMandatory = "Yes"
          />
          <EditableRow
            field="title"
            label="Title"
            value={values}
            callback={setValues}
          />      
          <EditableRow
            field="company"
            label="Company"
            value={values}
            callback={setValues}
          />
          <EditableRowWithDate
            field="birth"
            label="Birthday"
            placeholder=""
            value={values}
            callback={setValues}
          />
          <EditableRow
            field="highSchool"
            label="High School"
            value={values}
            callback={setValues}
          />
          <EditableRow
            field="collegeOne"
            label="College One"
            value={values}
            callback={setValues}
          />
          <EditableRow
            field="collegeTwo"
            label="College Two"
            value={values}
            callback={setValues}
          />
          <hr />
          <EditableRowWithType
            field="emailOne"
            label="Email"
            value={values}
            callback={setValues}
          />
          <hr />
          <EditableRowWithType
            field="phoneOne"
            label="Phone"
            value={values}
            callback={setValues}
          />
          <hr />
          <EditableRowAddress
            field="addressOne"
            label="Address"
            value={values}
            callback={setValues}
          />
          <hr />
          <EditableRow
            field="facebook"
            label="Facebook"
            value={values}
            callback={setValues}
          />
          <EditableRow
            field="linkedIn"
            label="LinkedIn"
            value={values}
            callback={setValues}
          />
          <EditableRow
            field="instagram"
            label="Instagram"
            value={values}
            callback={setValues}
          />
          <EditableRow
            field="twitter"
            label="Twitter"
            value={values}
            callback={setValues}
          />
          <EditableRow
            field="websiteOne"
            label="Website"
            value={values}
            callback={setValues}
          />
         
        {/* <EditImage
         field="pictureRef"
         label="Upload Image"
         value ={values}
         callback={setValues}
        /> */}
          {/* <input type="file" name="Imagesource" /> */}


        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button variant="outlined" type="submit" >
            Add Contact
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

function Image() {
  return (
   
           <UploadPreview />
         
  );
}

export class UploadPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = { file: null };
    this.onChange = this.onChange.bind(this);
    this.resetFile = this.resetFile.bind(this);
  }
  onChange(event) {
    this.setState({
      file: URL.createObjectURL(event.target.files[0])
    });
  }

  resetFile(event) {
    event.preventDefault();
    this.setState({ file: null });
    document.getElementById("pictureRef").value = "";
  }
  render() {
    return (
      <div>
        {this.state.file && (
      <div className="dataRow">
        <div className="dataRowLabel">
       
        </div>
               
      <div className="dataRowField">
       
          <div>
            <button onClick={this.resetFile}>Remove File</button>
          </div>
       
        <br></br>
        <img style={{ fontSize: "150px",
                lineHeight: "150px",
                height: "150px",
                width: "150px",borderRadius: 75, }} src={this.state.file} />
         <div>      
          <span className = "dataRowLabel"></span>      
       
         </div>
        </div>
        </div>
        )}
        <div className="dataRow">
          <div className = "dataRowLabel"><strong>Photo</strong></div>
          <div className = "dataRowField"> <input type="file" accept=".jpg,.jfif,.png" id="pictureRef" name="pictureRef" onChange={this.onChange} /></div>
        </div>
        </div>
    );
  }
}

export const ResourcesWidget = ({ wordpressId, nonce }) => {
  const [resources, setResources] = useState([]);
  const [open, setOpen] = useState(false);
  const [newResource, setNewResource] = useState({ description: "", link: "" });

  useEffect(() => {
    const init = async () => {
      await fetch("/wp-json/prism/v1/resources/" + wordpressId, {
        headers: { "X-WP-Nonce": nonce }
      })
        .then(response => response.json())
        .then(result => setResources(result));
    };
    if (wordpressId != null && nonce != null) {
      init();
    }
  }, [wordpressId, nonce]);

  const pushResource = async () => {
    await fetch("/wp-json/prism/v1/push-resource/", {
      method: "post",
      headers: { "Content-Type": "application/json", "X-WP-Nonce": nonce },
      body: JSON.stringify({
        wordpressId: wordpressId,
        description: newResource.description,
        link: newResource.link
      })
    })
      .then(response => response.json())
      .then(result => setResources(result));
  };

  const deleteResource = async id => {
    await fetch("/wp-json/prism/v1/delete-resource/", {
      method: "delete",
      headers: { "Content-Type": "application/json", "X-WP-Nonce": nonce },
      body: JSON.stringify({
        resourceId: id,
        wordpressId: wordpressId
      })
    })
      .then(response => response.json())
      .then(result => setResources(result));
  };

  return (
    <div>
      <div>
        Add{" "}
        <i
          className="icon-tiny fa fa-plus extra-color-gradient-2 clickable"
          onClick={() => setOpen(true)}
        />
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullWidth={true}
          maxWidth="sm"
        >
          <DialogTitle>Add Resource</DialogTitle>
          <div>
            <div>
              <input
                key="resourceDescription"
                type="text"
                placeholder="Resource Description (100 characters max)"
                value={newResource.description}
                onChange={e =>
                  setNewResource({
                    ...newResource,
                    description: e.target.value
                  })
                }
              />
            </div>
            <div>
              <input
                key="resourceLink"
                type="text"
                placeholder="Link"
                value={newResource.link}
                onChange={e =>
                  setNewResource({ ...newResource, link: e.target.value })
                }
              />
            </div>
          </div>
          <DialogActions>
            <Button variant="outlined" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button variant="outlined" onClick={() => pushResource()}>
              Add Resource
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div
        className="nectar-fancy-ul"
        data-list-icon="icon-salient-thin-line"
        data-animation="false"
        data-animation-delay="0"
        data-color="accent-color"
        data-spacing="default"
        data-alignment="left"
      >
        <ul>
          {resources.map(r => (
            <li key={r.id}>
              <i class="icon-default-style icon-salient-thin-line accent-color" />
              {r.description} -{" "}
              <a href={r.link} target="_blank" rel="noopener noreferrer">
                {r.link != null && r.link.length > 30
                  ? r.link.slice(0.3) + "..."
                  : r.link}
              </a>{" "}
              <i
                className="icon-tiny fa fa-trash-o extra-color-3"
                style={{ lineHeight: "normal", position: "relative" }}
                onClick={() => deleteResource(r.id)}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export const FollowUpLink = props => {
  return (
    <a
      href={
        "/prism/contact-detail/" +
        props.name +
        "/" +
        props.id +
        "?tab=notifications&contactId=" +
        props.id
      }
    >
      Set a follow-up
      <i className="icon-tiny fa fa-calendar-plus-o extra-color-gradient-2" />
    </a>
  );
};

export const fetchTasks = async props => {
  await fetch("/wp-json/prism/v1/tasks/", {
    method: "post",
    headers: { "Content-Type": "application/json", "X-WP-Nonce": props.nonce },
    body: JSON.stringify({
      contactId: props.contactId,
      wordpressId: props.wordpressId,
      seriesId: props.seriesId,
      stageId: props.stageId
    })
  })
    .then(response => response.json())
    .then(result => props.callback(result));
};

export const pushTask = async props => {
  await fetch("/wp-json/prism/v1/push-task/", {
    method: "post",
    headers: { "Content-Type": "application/json", "X-WP-Nonce": props.nonce },
    body: JSON.stringify({
      id: props.id,
      contactId: props.contactId,
      wordpressId: props.wordpressId,
      seriesId: props.seriesId,
      stageId: props.stageId,
      taskId: props.taskId
    })
  })
    .then(response => response.json())
    .then(result => props.callback(result));
};

export const HeroCard = ({ contact, pageType, manageCategoriesWidget }) => {
  return (
    <div
      className="vc_col-sm-4 wpb_column column_container vc_column_container col centered-text padding-1-percent"
      data-t-w-inherits="default"
      data-border-radius="none"
      data-shadow="none"
      data-border-animation=""
      data-border-animation-delay=""
      data-border-width="none"
      data-border-style="solid"
      data-border-color=""
      data-bg-cover=""
      data-padding-pos="all"
      data-has-bg-color="false"
      data-bg-color=""
      data-bg-opacity="1"
      data-hover-bg=""
      data-hover-bg-opacity="1"
      data-animation=""
      data-delay="0"
    >
      <div className="vc_column-inner">
        <div className="column-bg-overlay-wrap" data-bg-animation="none">
          <div className="column-bg-overlay" />
        </div>
        <div className="wpb_wrapper">
          <div
            className="nectar_icon_wrap"
            data-style="default"
            data-draw=""
            data-border-thickness="2px"
            data-padding="0px"
            data-color="extra-color-1"
          >
            <div className="nectar_icon">
             <Profileimage contact={contact} />
            </div>
          </div>
          <div className="wpb_text_column wpb_content_element ">
            <div className="wpb_wrapper">
              <h3 style={contact != null ? contact.firstName == "Missing"||contact.lastName == "Missing"?{color:"red"}:{}:null}>
                {contact != null ? contact.firstName : null}{" "}
                {contact != null ? contact.lastName : null}
              </h3>
            </div>
          </div>

          <div className="wpb_text_column wpb_content_element ">
            <div className="wpb_wrapper">
              {contact != null && (contact.title || contact.company) ? (
                <h5>
                  {contact.title != null ? contact.title+"," : ""}{contact.company}
                </h5>
              ) : null}
              <SocialLinks contact={contact} />
            </div>
          </div>

          <DividerWrapSmall style={{ backgroundColor: "rgba(0,0,0,0.12)" }} />
          <div
            className="nectar-cta "
            data-color="default"
            data-using-bg="false"
            data-style="see-through"
            data-display="block"
            data-alignment="center"
            data-text-color="custom"
          >
            <h6 style={{ color: "#1e83ec" }}>
              <span className="link_wrap">
                {pageType === "Networking" ? (
                  <a
                    className="link_text"
                    href={
                      "/prism/contact-detail/" +
                      (contact != null
                        ? contact.name.replace(/\s/g, "")
                        : null) +
                      "/" +
                      (contact != null ? contact.id : null) +
                      "?contactId=" +
                      (contact != null ? contact.id : null)
                    }
                  >
                    Contact Details
                    <span className="arrow" />
                  </a>
                ) : (
                  <a
                    className="link_text"
                    href={
                      "/prism/contact-detail-networking/" +
                      (contact != null
                        ? contact.name.replace(/\s/g, "")
                        : null) +
                      "/" +
                      (contact != null ? contact.id : null) +
                      "/?" +
                      (contact != null && contact.networkingStage > -1 ? "tab=" + networkingSeries[0].stages[contact.networkingStage].name : null) +
                      "&contactId=" +
                      (contact != null ? contact.id : null)
                    }
                  >
                    Networking Process
                    <span className="arrow" />
                  </a>
                )}
              </span>
            </h6>
          </div>
          <div
            className="nectar-cta "
            data-color="default"
            data-using-bg="false"
            data-style="see-through"
            data-display="block"
            data-alignment="center"
            data-text-color="custom"
            style={{ display: "none" }}
          >
            <h6 style={{ color: "#1e83ec" }}>
              <span className="text"> </span>
              <span className="link_wrap">
                <a
                  className="link_text"
                  href={
                    "/prism/contact-detail-mentoring/" +
                    (contact != null ? contact.id : null) +
                    "?contactId=" +
                    (contact != null ? contact.id : null)
                  }
                >
                  Mentoring Series
                  <span className="arrow" />
                </a>
              </span>
            </h6>
          </div>
          <DividerWrapSmall style={{ backgroundColor: "rgba(0,0,0,0.12)" }} />
          <div className="wpb_text_column wpb_content_element ">
            <div className="wpb_wrapper">
              <div id="categoriesRow">
                <Tooltip title="Manage Categories">
                  <span>
                    Categories
                    {manageCategoriesWidget != null ? (
                      <span style={{ paddingLeft: "5px" }}>
                        {manageCategoriesWidget}
                      </span>
                    ) : null}
                  </span>
                </Tooltip>
              </div>
              <div>
                <span
                  style={{
                    fontSize: "small"
                  }}
                >
                  {contact != null && contact.categories != null
                    ? contact.categories
                    : null}
                </span>
              </div>
            </div>
          </div>

          <DividerWrapSmall style={{ backgroundColor: "rgba(0,0,0,0.12)" }} />
          <div className="wpb_text_column wpb_content_element ">
            <div className="wpb_wrapper">
              <ImportSource
                importSource={contact != null ? contact.importSource : null}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Events = props => {
 
  const reset = {
    id: null,
    title: "",
    type: "",
    date: new Date(),
    evdescription:"",
    day:"",
    month:"",
    year: "",
    isValid:false
  };
 
  const [events, setEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const [fields, setFields] = useState(reset);

  const fetchEvents = async contactId => {
    await fetch("/wp-json/prism/v1/events/" + contactId, {
      headers: { "X-WP-Nonce": props.nonce }
     
    })
      .then(response => response.json())
      .then(result => setEvents(result));
  };
  function isEventFormValid (){
    var days31 = ["1","3","5","7","8","10","12"].includes(fields.month);
    var days30 = ["4","6","9","11"].includes(fields.month);
    var dateRegEx = /^[0-9]+$/;
    if(fields.title ==""){
      alert ("Please enter the event name")
      return false; }
    else if(fields.month<1) {
      alert("Please select a month");
      return false; }
    else if(fields.day =="") {
      alert("Please enter a date");
      return false; }
    else if (!dateRegEx.test(fields.day)) {
        alert("Please enter only numeric values in the date");
         return false; }
    else if (fields.day.length != 2) {
        alert("Date is not proper. Please check");
        return false; }
    else if(fields.month == "2")
    {
      if(fields.year != "")
      {
        if((!(fields.year % 4) && fields.year % 100) || !(fields.year % 400))
        {
          if(fields.day > 29 || fields.day <= 0)
          {
            alert("Date is not proper. Please check");
            return false;
          }
        }
        else if(fields.day >28 || fields.day <= 0)
        {
          alert("Date is not proper. Please check");
          return false;
        }
      }
      else
      {
        if(fields.day > 29 || fields.day <= 0)
        {
        alert("Date is not proper. Please check");
        return false;
        }
        else {
          return true;
        }
    }
  }
  else if(days30 == true)
  {
        if(fields.day > 30 || fields.day <= 0){
          alert("Date is not proper. Please check");
          return false;
        }
        else{
          return true;
        }
  }
  else if(days31 == true)
  {
      if(fields.day > 31 || fields.day <= 0){
        alert("Date is not proper. Please check");
        return false;
      }
      else{
        return true;
      }
  }
  else
  {
      return true;
  }
  }

  const createEvent = async () => {
   
    var tempYear =fields.year==""?"0000":fields.year;
    var tempDay =fields.day;
    var tempMonth =fields.month
    if(tempDay == "29" && tempMonth =="2" && tempYear == "0000")
    {
       tempYear = "0004";
    }
    let concatDate = `${tempMonth}/${tempDay}/${tempYear}`;
        await fetch("/wp-json/prism/v1/create-event/", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": props.nonce
          },
          body: JSON.stringify({
            contactId: props.contactId,
            wordpressId: props.wordpressId,
            title: fields.title,
            date: concatDate,
            evdescription:fields.evdescription
          })
        })
          .then(response => response.json())
          .then(result => {
            setEvents(result);
            setFields(reset);
          });
   
  };

  const editEvent = async () => {
    var tempYear = (fields.year == "0" || fields.year == "" )?"0000":fields.year;
    var tempDay =fields.day;
    var tempMonth =fields.month
    if(tempDay == "29" && tempMonth =="2" && tempYear == "0000")
    {
       tempYear = "0004";
    }
    let concatDate = `${tempMonth}/${tempDay}/${tempYear}`;
    await fetch("/wp-json/prism/v1/update-event/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        id: fields.id,
        contactId: props.contactId,
        wordpressId: props.wordpressId,
        title: fields.title,
        date: concatDate,
        evdescription: fields.evdescription
      })
    })
      .then(response => response.json())
      .then(result => {
        setEvents(result);
        setFields(reset);
      });
  };

  const deleteEvent = async eventId => {
    if (window.confirm("Are you sure you want to delete this?")) {
      await fetch("/wp-json/prism/v1/delete-event/", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": props.nonce
        },
        body: JSON.stringify({ id: eventId, contactId: props.contactId })
      })
        .then(response => response.json())
        .then(result => setEvents(result));
    }
  };

  const toggleEvent = async eventId => {
    await fetch("/wp-json/prism/v1/toggle-event/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        contactId: props.contactId,
        EventId: eventId
      })
    })
      .then(response => response.json())
      .then(result => setEvents(result));
  };

  useEffect(() => {
    if (props.contactId != null && props.nonce != null)
      fetchEvents(props.contactId);
  }, [props.contactId, props.nonce]);

  const Event = ({ event }) => {
    return (
      <div className="event">
        <div className="title">{event.title}</div>
        <div className="date">{event.date.split("/")[2]=="0000"?event.date.replace("0000","----"):event.date.split("/")[2]=="0004" ? event.date.replace("0004","----") : event.date}</div>
        <div className="date">{event.evdescription}</div>

        <div className="action">
          <i
            className="icon-tiny fa fa-pencil extra-color-3 clickable"
            style={{ color: "#a3a3a3" }}
            onClick={() => {
              setFields({
                id: event.id,
                title: event.title,
                date: event.date,
                evdescription: event.evdescription,
                day:event.day.length === 1 ? '0'+event.day : event.day,
                month:event.month,
                year:event.year == 4 ? event.year = "" : event.year
              });
              setOpen(true);
            }}
          />
          <i
            className="icon-tiny fa fa-trash-o extra-color-3 clickable"
            style={{ color: "#a3a3a3" }}
            onClick={() => deleteEvent(event.id)}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="eventsWidget">
      {props.showHeader ? (
        <div className="eventHeader">
          <h3>
            Events{" "}
            <i
              className="icon-tiny fa fa-plus extra-color-2 clickable"
              onClick={() => {
                setFields(reset);
                setOpen(true);
              }}
            />
          </h3>

          <Dialog
            open={open}
            maxWidth="sm"
            fullWidth={true}
            onClose={() => {
              setFields(reset);
              setOpen(false);
            }}
            scroll="body"
          >
            <DialogTitle>
              {fields != null && fields.id != null ? "Edit" : "Add"} Event
            </DialogTitle>
            <DialogContent dividers>
              <div>
                <span style={{width: "79px"}}>Event Name</span>
                <input
                  key="eventName"
                  type="text"
                  length="40"
                  name="name"
                  placeholder="Event Name"
                  value={fields.title}
                  style={{width: "429px", margin:"1%"}}
                  required={true}
                  onChange={e =>
                    setFields({ ...fields, title: e.target.value })
                  }
                  className="prism form-control"
                />
              </div>


              <div>
                <span>
                  Date:
                </span>
                  <select
                 name="month"
                 value={fields.month}
                 onChange={e => setFields({ ...fields, month: e.target.value })}
                 style={{width: "137px", margin:"1%"}}
                 //defaultValue={{label:}}
                 required={true}
                  >
                    <option value="0" selected>Select a Month </option>
                    <option value="1" >January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                   </select>
                <input
                  type="text"
                  maxlength="2"
                  name="day"
                  placeholder="DD"
                  value={fields.day}
                  onChange={e => setFields({ ...fields, day: e.target.value })}
                  className="prism form-control"
                  style={{width: "79px", margin:"1%"}}
                  required={true}
                />

                  <input
                  type="text"
                  maxlength="4"
                  name="Year"
                  placeholder="YYYY"
                  value={fields.year=="0"? "":fields.year}
                  onChange={e => setFields({ ...fields, year: e.target.value })}
                  className="prism form-control"
                  style={{width: "82px", margin:"1%"}}
                />
                year optional
              </div>
              <div>
              <span>
              Description:
                </span>
                <input
                  key="DescriptionName"
                  type="text"
                  length="40"
                  name="evdescription"
                  placeholder="Your Description"
                  value={fields.evdescription}
                  onChange={e => setFields({ ...fields, evdescription: e.target.value })}
                  className="prism form-control"
                />
              </div>
           
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                onClick={() => {
                  setOpen(false);
                  setFields(reset);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  if (fields.id === null) {
                    if(isEventFormValid())
                      {
                        createEvent(); setOpen(false);
                      }
                      else{
                       // setFields(reset);
                        setOpen(true);
                      }
                  } else {
                    if(isEventFormValid())
                      {editEvent(); setOpen(false);}
                      else{
                        //setFields(reset);
                        setOpen(true);
                       }
                  }
                 //
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      ) : null}
      {events != null ? events.map(e => <Event key={e.id} event={e} />) : null}
    </div>
  );
};

export const Followups = props => {
  const reset = {
    id: null,
    complete: false,
    title: "",
    description: "",
    day:"",
    month:"",
    year: "",
    isValid:false,
    date: new Date()
  };
 
  const [followups, setFollowups] = useState([]);
  const [open, setOpen] = useState(false);
  const [fields, setFields] = useState(reset);

  const fetchFollowups = async contactId => {
    await fetch("/wp-json/prism/v1/followups/" + contactId, {
      headers: { "X-WP-Nonce": props.nonce }
    })
      .then(response => response.json())
      .then(result => setFollowups(result));
  };

  const createFollowup = async () => {
    var tempYear =fields.year==""?"0000":fields.year;
    var tempDay =fields.day;
    var tempMonth =fields.month
    let concatDate = `${tempMonth}/${tempDay}/${tempYear}`;
    await fetch("/wp-json/prism/v1/create-followup/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        contactId: props.contactId,
        wordpressId: props.wordpressId,
        title: fields.title,
        desc: fields.desc,
        date: concatDate//fields.date
       
      })
    })
      .then(response => response.json())
      .then(result => {
        setFollowups(result);
        setFields(reset);
      });
  };

  const editFollowup = async () => {
    var tempYear =fields.year==""?"0000":fields.year;
    var tempDay =fields.day;
    var tempMonth =fields.month
    let concatDate = `${tempMonth}/${tempDay}/${tempYear}`;
    await fetch("/wp-json/prism/v1/update-followup/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        id: fields.id,
        contactId: props.contactId,
        wordpressId: props.wordpressId,
        title: fields.title,
        desc: fields.desc,
        date: concatDate//fields.date
      })
    })
      .then(response => response.json())
      .then(result => {
        setFollowups(result);
        setFields(reset);
      });
  };

  const deleteFollowup = async id => {
    if (window.confirm("Are you sure you want to delete this?")) {
      await fetch("/wp-json/prism/v1/delete-followup/", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": props.nonce
        },
        body: JSON.stringify({ id: id, contactId: props.contactId })
      })
        .then(response => response.json())
        .then(result => setFollowups(result));
    }
  };

  const toggleFollowup = async followupId => {
    await fetch("/wp-json/prism/v1/toggle-followup/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        contactId: props.contactId,
        followupId: followupId
      })
    })
      .then(response => response.json())
      .then(result => setFollowups(result));
  };

  useEffect(() => {
    if (props.contactId != null) fetchFollowups(props.contactId);
  }, [props.contactId]);


  function isFollowUpFormValid (){
    var days31 = ["1","3","5","7","8","10","12"].includes(fields.month);
    var days30 = ["4","6","9","11"].includes(fields.month);
    var dateRegEx = /^[0-9]+$/;
    if(fields.title ==""){
      alert ("Please enter the follow-up name")
      return false; }
    else if(fields.month<1) {
      alert("Please select a month");
      return false; }
    else if(fields.day =="") {
      alert("Please enter a date");
      return false; }
    else if (!dateRegEx.test(fields.day)) {
        alert("Please enter only numeric values in the date");
         return false; }
    else if (fields.day.length != 2) {
        alert("Date is not proper. Please check");
        return false; }  
    else if(fields.year == "") {
        alert("Please enter a year");
        return false; }
    else if (!dateRegEx.test(fields.year)) {
        alert("Please enter only numeric values in the year");
         return false; }
    else if (fields.year.length != 4) {
          alert("Year is not proper. Please check");
          return false; }  
    else if(fields.month == "2")
    {
        if((!(fields.year % 4) && fields.year % 100) || !(fields.year % 400))
        {
          if(fields.day > 29 || fields.day <= 0)
          {
            alert("Date is not proper. Please check");
            return false;
          }
        }
        else if(fields.day >28 || fields.day <= 0)
        {
          alert("Date is not proper. Please check");
          return false;
        }
        else{
          return true;
        }
    }
    else if(days30 == true)
    {
        if(fields.day > 30 || fields.day <= 0)
        {
          alert("Date is not proper. Please check");
          return false;
        }
        else{
          return true;
        }
    }
    else if(days31 == true)
    {
      if(fields.day > 31 || fields.day <= 0)
      {
        alert("Date is not proper. Please check");
        return false;
      }
      else
      {
        return true;
      }
    }
    else{
      return true;
    }
  }
  const Followup = ({ followup }) => {
    return (
      <div className="followup">
        <div className="title">
          <input
            key={"completeFollowup" + followup.id}
            type="checkbox"
            checked={followup.complete !== "0"}
            onChange={() => toggleFollowup(followup.id)}
          />
          {followup.title}
        </div>
        <div className="desc">{followup.desc}</div>
        <div className="date">{followup.date}</div>
        <div className="action">
          <i
            className="icon-tiny fa fa-pencil extra-color-3 clickable"
            style={{ color: "#a3a3a3" }}
            onClick={() => {
              setFields({
                id: followup.id,
                title: followup.title,
                desc: followup.desc,
                date: followup.date,
                day:followup.day.length === 1 ? '0'+followup.day : followup.day,
                month:followup.month,
                year:followup.year
              });
              setOpen(true);
            }}
          />
          <i
            className="icon-tiny fa fa-trash-o extra-color-3 clickable"
            style={{ color: "#a3a3a3" }}
            onClick={() => deleteFollowup(followup.id)}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="followupsWidget">
      {props.showHeader ? (
        <div className="follwupHeader">
          <h3>
            Follow-ups{" "}
            <i
              className="icon-tiny fa fa-plus extra-color-2 clickable"
              onClick={() => {
                setFields(reset);
                setOpen(true);
              }}
            />
          </h3>

          <Dialog
            open={open}
            onClose={() => {
              setFields(reset);
              setOpen(false);
            }}
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogTitle>
              {fields != null && fields.id != null ? "Edit" : "Add"} FollowUp
            </DialogTitle>
            <DialogContent dividers>
              <div>
                <input
                  key="followUpName"
                  type="text"
                  length="40"
                  name="title"
                  placeholder="FollowUp Name"
                  value={fields.title}
                  onChange={e =>
                    setFields({ ...fields, title: e.target.value })
                  }
                  className="prism"
                />
              </div>
              <div>
                <span>
                  Date:
                </span>
                {/* <input
                  type="text"
                  length="40"
                  name="month"
                  placeholder="MM"
                  value={fields.month}
                  onChange={e => setFields({ ...fields, month: e.target.value })}
                  //className="prism"
                  style={{width: "79px", margin:"1%"}}
                /> */}


                  <select
                 name="month"
                 value={fields.month}
                 onChange={e => setFields({ ...fields, month: e.target.value })}
                 style={{width: "137px", margin:"1%"}}
                 //defaultValue={{label:}}
                 required={true}
                  >
                    <option value="0" selected>Select a Month </option>
                    <option value="1" >January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                   </select>
                <input
                  type="text"
                  maxlength="2"
                  name="day"
                  placeholder="DD"
                  value={fields.day}
                  onChange={e => setFields({ ...fields, day: e.target.value })}
                  className="prism form-control"
                  style={{width: "79px", margin:"1%"}}
                  required={true}
                />

                  <input
                  type="text"
                  maxlength="4"
                  name="Year"
                  placeholder="YYYY"
                  value={fields.year=="0"? "":fields.year}

                  onChange={e => setFields({ ...fields, year: e.target.value })}
                  className="prism form-control"
                  style={{width: "82px", margin:"1%"}}
                  required={true}
                />
              </div>
              <div>          
              </div>
              <div>
                <input
                  key="followUpDescription"
                  type="text"
                  length="100"
                  placeholder="Description"
                  value={fields.desc}
                  onChange={e => setFields({ ...fields, desc: e.target.value })}
                  className="prism"
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                onClick={() => {
                  setOpen(false);
                  setFields(reset);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  if (fields.id === null) {
                    if(isFollowUpFormValid())
                    {
                    createFollowup(); setOpen(false);
                    }
                    else{
                      // setFields(reset);
                       setOpen(true);
                     }
                  } else {
                    if(isFollowUpFormValid())
                    {
                    editFollowup();  setOpen(false);
                    }
                    else{
                      setOpen(true);
                    }
                  }
                  //setOpen(false);
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      ) : null}
      {followups != null && followups.length > 0 ? (
        <div>
          <h5>Incomplete</h5>
          {followups
            .filter(e => e.complete === "0")
            .map(e => (
              <Followup key={e.id} followup={e} />
            ))}
        </div>
      ) : null}
      {followups != null && followups.length > 0 ? (
        <div>
          <h5>Complete</h5>
          {followups
            .filter(e => e.complete === "1")
            .map(e => (
              <Followup key={e.id} followup={e} />
            ))}
        </div>
      ) : null}
    </div>
  );
};

export const networkingSeries = [
  {
    id: 1,
    name: "Networking Process",
    subHeadingOne:
      "THE PRISM NETWORKING PROCESS CONSISTS OF SIX STAGES THAT HELP YOU TO BUILD AND STRENGTHEN YOUR RELATIONSHIPS.",
    subHeadingTwo:
      "Our process is for everyone, from college students to business professionals, who recognize the role that better relationships play in successful lives.",
    description:
      "<ul><li>First, you BUILD your relationships by entering in basic information that you know about each person.</li><li>Before connecting with a person, you’ll want to DISCOVER more about them to learn how you might be of value to each other.</li><li>Once you’ve updated the contact information, and done your research, you set up a CONNECT meeting or call to continue building the relationship.</li><li>Then you ASSESS your relationship to determine what opportunities you both mutually have to work with or help each other, whether for personal or professional goals.</li><li>If you identify a specific opportunity with a contact, you ENGAGE in working together or connecting further.</li><li>The final stage of PRISM Networking is to MAINTAIN your relationship by staying in touch and maintaining a genuine presence in their life.</li></ul>",
    stages: [
      {
        id: 0,
        name: "BUILD",
        icon: "iconsmind-Wrench",
        description:
          "At this stage, your main goal is to BUILD details on your contacts after you have entered them into PRISM. This includes adding all the information you know (social, family, careers, interests) as well as any social media links. As you do this step, assign them to existing categories or create new ones. The reason to take the time to BUILD out all that know about someone is that this is an important step in setting up your PRISM personal relationship management tool. The better your content, the better the system will work for you to create genuine relationships.",
        resources: [
          {
            id: 1,
            description:
              "You Can’t Take It With Your…Your CRM is Locked in the Corporate Vault",
            href:
              "http://xyz.idktechnology.com/you-cant-take-it-with-youyour-crm-is-locked-in-the-corporate-vault/"
          }
        ],
        tasks: [
          {
            id: 0,
            task:
              "Add all information that you already know about this person into thier contact record, including email and cell phones, and addresses if not completed through the import process."
          },
          {
            id: 1,
            task:
              "Copy any additional links of this person’s social media pages (Facebook, LinkedIn, Instagram, etc.) into their record."
          },
          {
            id: 2,
            task:
              "Create and assign different categories based on their interests and how you are connected."
          }
        ],
        tips: [
          {
            id: 0,
            tip:
              "Helpful information to add includes: family members, jobs, universities, sports played or coached, church and other organization affiliations such as clubs, fraternities, and more."
          }
        ]
      },
      {
        id: 1,
        name: "DISCOVER",
        icon: "iconsmind-Search-People",
        description:
          "At this stage, your objective is to DISCOVER something new about this individual and capture it back into the PRISM system. You want to learn all the possible categories you can assign to them, which will help you think of future interactions, introductions, and other networking or opportunities you might have together. This stage is the opportunity to dig a little deeper into learning about this person by checking their social media pages and adding the links into PRISM. These are detailed facts that you might not know without doing further research, such as how long someone has worked at a company, what sports they played in college, and so forth. You can create as many categories as you would like to assign to someone, however, also think broadly about which categories others may have in common. It will help when you search and try to determine connections, introductions, and networking opportunities across your network.",
        resources: [
          {
            id: 0,
            description: "The PRISM 5 Minute Methodology",
            href: "http://xyz.idktechnology.com/the-prism-5-minute-methodology/"
          }
        ],
        tasks: [
          {
            id: 0,
            task:
              "Review contact's social media pages to discover more about this person, and learn what you might have in common, including which shared friends or connections you may have. Add to your Notes the people you have in common."
          },
          {
            id: 1,
            task:
              "Research other areas of interest (companies, universities, volunteer organizations) to understand more about this person and add to their contact record."
          },
          {
            id: 2,
            task:
              "Add any additional information you have found by assigning specific categories or entering details into Notes."
          }
        ],
        tips: [
          {
            id: 0,
            tip:
              "You can create as many categories as you would like to assign to someone, however, also think broadly about which categories others may have in common. It will help when you search and try to determine connections, introductions, and networking opportunities this contact might have with others in your network."
          }
        ]
      },
      {
        id: 2,
        name: "CONNECT",
        icon: "iconsmind-Plastic-CupPhone",
        description:
          "At this stage, your main goal is to set up a time to CONNECT, during a meeting or phone call. Each time you meet with someone, you should gather information about them and enter it into your PRISM Notes. A meeting would ideally be face to face and could be a casual coffee or afternoon walk, or even a quick phone call. This connection point is the pivotal time in your PRISM Networking process. You have identified individuals with whom you wish to build a better relationship and learn more about them, their careers, or their interests. Perhaps not everyone you identify will have the time to meet with you in your desired time frame. If you hit a dead end with someone when you try to set up a connection point, then set a reminder for 2-3 months out, and reach out again.",
        resources: [
          {
            id: 0,
            description: "Insert Resource Here",
            href: "http://google.com"
          }
        ],
        tasks: [
          {
            id: 0,
            task:
              "Set up a call or meeting via email, phone call, or text with this contact."
          },
          {
            id: 1,
            task:
             ["Use ", <a href="/prism-information-gathering-template/" target="_blank" rel="noopener noreferrer"><strong>the PRISM Networking Guide</strong></a>, " an information gathering template for contact meetings, to help identify how you can mutually add value to each others lifes work moving forward."]
          },
          {
            id: 2,
            task:
              "Enter new information into PRISM about the person and assign categories based on their interests."
          }
        ],
        tips: [
          {
            id: 0,
            tip:
              "Use Notes to track general details, including where you met, and key takeaways from your conversation. These details may help you to remember specifics better and be a place to gather additional information."
          },
          {
            id: 1,
            tip:
            ["Practice the ", <a href="/the-prism-5-minute-methodology/" target="_blank" rel="noopener noreferrer">5 Minute PRISM Networking Methodology</a>, ", which recommends taking 5 minutes, within 24 hours of meeting with someone to capture this information in your PRISM Notes."]
          }
        ]
      },
      {
        id: 3,
        name: "ASSESS",
        icon: "iconsmind-Puzzle",
        description:
          "At this stage, you are working on finding opportunities to deepen the relationship with this individual to assess what you can work on with this person, who you may be able to introduce them to, or who they might introduce to you. During the ASSESS stage, it is beneficial to reflect on what you have learned in previous stages, especially during your CONNECT meeting. In doing so, you may realize that you do not want to pursue a deeper relationship. Or you can set a reminder to follow up a few months into the future to see where the relationship stands. A contact could be in ASSESS for many months, where prior stages may have been completed more quickly.",
        resources: [
          {
            id: 0,
            description: "Insert Resource Here",
            href: "http://google.com"
          }
        ],
        tasks: [
          {
            id: 0,
            task:
              "Send a written thank you note, via email or mail, within 24 hours of meeting with the person. Reiterate what you learned that was especially interesting or unique to the person, and include follow up information if there is something that you committed to sending."
          },
          {
            id: 1,
            task:
              "Complete additional research that you want to learn about this person and add this info to PRISM."
          },
          {
            id: 2,
            task:
              "Determine whether you think this relationship is growing genuine enough to add value to each other in the near future."
          }
        ],
        tips: [
          {
            id: 0,
            tip:
              "Building trust is the best way to build a genuine relationship with someone. It is also important to be someone who gives back, so remember to offer help, referrals, or introductions when you can."
          },
          {
            id: 1,
            tip:
              "If you can’t identify any reasons right now to continue networking with this person, don’t mark this stage complete. Instead, set a follow-up reminder for yourself in 1-3 months to consider it again. Some relationships take more time and different experiences to become mutually valuable."
          }
        ]
      },
      {
        id: 4,
        name: "ASSESS",
        icon: "iconsmind-Checked-User",
        description:
          "At this stage, your contacts are here because you have identified a specific opportunity to work with them to create mutually beneficial value. These may be related to a business or career opportunity or related to a passion you share. Your contacts may remain in ENGAGE for many months. PRISM is a personal relationship management system, so keep in mind that the goal at this stage is to be making truly genuine connections. The goal should not be to do a hard “customer sell,” however, eventually, that might be a natural outcome. By building better relationships, everyone involved should be enriched by the engagement. One idea of engaging further could be to introduce this person to others in your network if you have determined that they all have a shared interest through similar categories.",
        resources: [
          {
            id: 0,
            description: "The 24/7/30 Principle",
            href: "http://xyz.idktechnology.com/the-24-7-30-principle/"
          }
        ],
        tasks: [
          {
            id: 0,
            task:
              "Set a follow-up to email or call this person in 30 days to schedule another meeting, especially try for face to face if this did not happen in the first meeting."
          },
          {
            id: 1,
            task:
              "Find a book or article that you think this person would like to read and email them a link to it. Or think of mutual connections and introduce them to each other. Keep a copy of what you sent them in a link or sentence or two in notes."
          },
          { id: 2, task: "Keep a link or list of articles." }
        ],
        tips: [
          {
            id: 0,
            tip:
              "The ENGAGE stage is about engaging with someone because you believe in who they are, what they are doing, and/or have an opportunity to work with this person or contribute to something that they are doing. A PRISM Networking belief is that genuine relationships are achieved by being known, trusted, responsible, and present."
          }
        ]
      },
      {
        id: 5,
        name: "MAINTAIN",
        icon: "iconsmind-Heart2",
        description:
          "At this stage, MAINTAIN equates to the fact that you have completed all prior stages and many tasks in the PRISM Networking process with a contact. To maintain good relationships, you need to keep in touch by determining what the right frequency is for meeting face to face. Genuine relationships are never really complete, and all relationships need maintenance. Determine how often you should meet, and then use PRISM and calendar reminders to make sure that you stick to the plan. If you decide that your relationship is stagnant, then we recommend that you go back a few steps in the PRISM Networking process and do a relationship reboot. By reviewing prior notes and completing new tasks at the other stages, you might find the relationship regains its strength.",
        resources: [
          {
            id: 0,
            description:
              "Why 10 Genuine Relationships are Better than 1000 Likes",
            href:
              "http://xyz.idktechnology.com/why-10-genuine-relationships-are-better-than-1000-likes/"
          }
        ],
        tasks: [
          {
            id: 0,
            task:
              "Make sure you are up to date in sending thank you notes or emails after your last meeting or phone call."
          },
          {
            id: 1,
            task:
              "If there is a business or networking opportunity that you think is mutually beneficial or someone you would like to connect them with, set up a meeting."
          },
          {
            id: 2,
            task:
              "Plan to connect with this person at least once a month with a friendly phone call, follow up to information discussed, send them an interesting article, or to wish them a Happy Birthday or special milestone. Remember to add these connection points to your notes."
          },
          {
            id: 3,
            task:
              "If you decide at some point that this is a relationship that you no longer want to maintain, then assign a category to reflect this. Some options could be: do not contact, moved out of town, deceased, or whatever the situation is."
          }
        ],
        tips: [
          {
            id: 0,
            tip:
              "Have several contacts with shared interests? Plan a small group event, which maximizes everyone’s time, and you are helping others connect."
          },
          {
            id: 1,
            tip:
              "One can always be learning something new about someone or learning something new from someone. So keep adding to your PRISM Notes and update your categories as you continue building your relationship."
          },
          {
            id: 2,
            tip:
              "You may feel that this relationship is valuable enough to take to the next level, which is to engage with them as a mentor or mentee. Learn more about Mentoring in PRISM."
          },
          {
            id: 3,
            tip:
              "Part of maintaining a relationship is ongoing DISCOVER, ASSESS, and ENGAGE. So if you go back to one of these stages and check “In Progress,” then it will uncheck all future tasks. You will be able to start from that point and complete the stages again. While the tasks will become unchecked, your notes will be saved."
          }
        ]
      }
    ]
  }
];

export const mentors = [
  { id: 1, name: "Bill Gates", seriesId: 1 },
  { id: 2, name: "Jeff Bezos", seriesId: 1 },
  { id: 3, name: "Jesus", seriesId: 2 }
];

export const mentees = [
  { id: 1, name: "Steve McFuckup", seriesId: 1 },
  { id: 2, name: "Angie CantDoIt", seriesId: 2 },
  { id: 3, name: "Ronald McDonald", seriesId: 1 }
];

export const mentoringSeries = [
  {
    id: 1,
    name: "Career Transition",
    shortDescription:
      "The Purpose of this series is to help a person who has begun his or her career to aid a college-aged individual with their education and career decisions.",
    longDescription:
      "Description of the mentoring series. I am text block.Click edit button to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
    who: "who is this series for description",
    milestones: [
      {
        id: 1,
        name: "First Milestone",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 2,
        name: "Second Milestone",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 3,
        name: "Third Milestone",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 4,
        name: "Fourth Milestone",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 5,
        name: "Fifth Milestone",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 6,
        name: "Sixth Milestone",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      }
    ]
  },
  {
    id: 2,
    name: "Website Creation",
    shortDescription: "shortDescription",
    longDescription: "longDescription",
    who: "Who",
    milestones: [
      {
        id: 1,
        name: "Design",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 2,
        name: "Architect",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 3,
        name: "Build",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 4,
        name: "Test",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 5,
        name: "Release",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      },
      {
        id: 6,
        name: "Bro Down",
        tasks: [
          { id: 1, name: "First Task" },
          { id: 2, name: "Second Task" },
          { id: 3, name: "Third Task" },
          { id: 4, name: "Fourth Task" }
        ]
      }
    ]
  }
];

export const styles = {
  iconArrowDown: "icon-tiny iconsmind-Arrow-Down extra-color-2",
  iconArrowUp: "icon-tiny iconsmind-Arrow-Up extra-color-2",
  iconTag: "icon-tiny fa fa-tag extra-color-3",
  iconPlus: "icon-tiny fa fa-plus extra-color-2",
  iconAdd: "icon-normal fa fa-plus-circle extra-color-gradient-2",
  iconImport: "icon-normal fa fa-arrow-circle-up extra-color-gradient-2",
  iconContacts: "icon-tiny fa fa-address-book-o extra-color-3",
  iconRecent: "icon-tiny fa fa-history extra-color-3",
  iconBuild: "icon-tiny iconsmind-Add-User extra-color-3",
  iconConnect: "icon-tiny iconsmind-Plastic-CupPhone extra-color-3",
  iconDiscover: "icon-tiny iconsmind-Search-People extra-color-3",
  iconAssess: "icon-tiny iconsmind-Puzzle extra-color-3",
  iconEngage: "icon-tiny iconsmind-Speach-BubbleComic3 extra-color-3",
  iconMaintain: "icon-tiny iconsmind-Love-User extra-color-3",
  iconInProgress: "icon-tiny fa fa-hourglass-half extra-color-3",
  iconComplete: "icon-tiny fa fa-check extra-color-3",
  iconDoNotContact: "icon-tiny fa fa-times extra-color-3",
  iconMentor: "icon-tiny fa fa-diamond extra-color-3",
  iconMentee: "icon-tiny icon-leaf extra-color-3",
  iconAvatar: "fa fa-user-circle iconAvatar",
  iconEmail: "icon-tiny fa fa-envelope-o extra-color-3",
  iconPhone: "icon-tiny fa fa-phone extra-color-3",
  iconLinkedIn: "icon-tiny fa fa-linkedin-square accent-color",
  iconFacebook: "icon-tiny fa fa-facebook-square accent-color",
  iconInstagram: "icon-tiny fa fa-instagram accent-color",
  iconTwitter: "icon-tiny fa fa-twitter-square accent-color",
  iconWebsite: "icon-tiny fa fa-link accent-color",
  iconSortAsc: "icon-tiny fa fa-sort-alpha-asc extra-color-3",
  iconSortDesc: "icon-tiny fa fa-sort-alpha-desc extra-color-3",
  iconSearch: "icon-default-style iconsmind-Magnifi-Glass22 extra-color-2",
  iconSelectAll: "icon-default-style fa fa-square-o extra-color-3",
  iconGoogle: "icon-tiny fa fa-google extra-color-1",
  iconApple: "icon-tiny fa fa-apple extra-color-1",
  iconFacebookHollow: "icon-tiny fa fa-facebook extra-color-1",
  iconLinkedInHollow: "icon-tiny fa fa-linkedin extra-color-1",
  iconFile: "icon-tiny fa fa fa-file-o extra-color-1"
};

export const ArrowIndicator = props => {
  return props.open ? (
    <i className={styles.iconArrowDown} />
  ) : (
    <i className={styles.iconArrowUp} />
  );
};

export const Profileimage=props=>
{
  const hasImage = props.contact != null && (props.contact.pictureRef!= null );
      const Link = p => {
        class UploadPreview extends React.Component {

          constructor(props) {
            super(props);
            this.state = { file: null };
            this.onChange = this.onChange.bind(this);
            this.resetFile = this.resetFile.bind(this);
          }
          onChange(event) {
            this.setState({
              file: URL.createObjectURL(event.target.files[0])
            });
          }
       
          resetFile(event) {
            event.preventDefault();
            this.setState({ file: null });
          }
          render() {
            return (
              <div>
               
                {this.state.file && (
                  <div style={{ textAlign: "center" }}>
                    <button onClick={this.resetFile}>Remove File</button>
                  </div>
                )}
                <img style={{
               fontSize: "150px",
                lineHeight: "150px",
                height: "150px",
                width: "150px",
                borderRadius: 75,
             }} src={p.src} />
              </div>
            );
          }
        }
        return (
         
      //     <img
      //       src={p.src}
      //       style={{
      //         fontSize: "150px",
      //         lineHeight: "150px",
      //         height: "150px",
      //         width: "150px",
      //         borderRadius: 75,
      //       }}
      // className="fa fa-user-circle"
      // />
      <UploadPreview></UploadPreview>
     
        );
      };
      return hasImage?(
        <div>
         {props.contact.pictureRef  ==null || props.contact.pictureRef =="" ?(

          <i
          style={{
            fontSize: "150px",
            lineHeight: "150px",
            height: "150px",
            width: "150px",
           
          }}
          className="fa fa-user-circle"
          />
      ):
       
      <Link src={props.contact.pictureRef}>
      </Link>
     
      }
      </div>):
      <i
      style={{
        fontSize: "150px",
        lineHeight: "150px",
        height: "150px",
        width: "150px",
       
      }}
      className="fa fa-user-circle"
    />;
}

export const SocialLinks = props => {
  const hasLinks =
    props.contact != null &&
    (props.contact.linkedIn !== null ||
      props.contact.facebook !== null ||
      props.contact.instagram !== null ||
      props.contact.twitter !== null ||
      props.contact.websiteOne !== null);
  const Link = p => {
    return (
      <a href={(p.href.toLowerCase().startsWith('www') ? "//" : p.href.toLowerCase().startsWith('http') ? "" : "//") + p.href} target="_blank" rel="noopener noreferrer">
        {p.children}
      </a>
    );
  };
  return hasLinks ? (
    <div>
      {props.contact.linkedIn != null ? (
        <Link href={props.contact.linkedIn}>
          <i className="icon-tiny fa fa-linkedin-square accent-color" />
        </Link>
      ) : null}
      {props.contact.facebook != null ? (
        <Link href={props.contact.facebook}>
          <i className="icon-tiny fa fa-facebook-square accent-color" />
        </Link>
      ) : null}
      {props.contact.instagram != null ? (
        <Link href={props.contact.instagram}>
          <i className="icon-tiny fa fa-instagram accent-color" />
        </Link>
      ) : null}
      {props.contact.twitter != null ? (
        <Link href={props.contact.twitter}>
          <i className="icon-tiny fa fa-twitter-square accent-color" />
        </Link>
      ) : null}
      {props.contact.websiteOne != null ? (
        <Link href={props.contact.websiteOne}>
          <i className="icon-tiny fa fa-link accent-color" />
        </Link>
      ) : null}
    </div>
  ) : null;
};

export const ImportSource = props => {
  return (
    <div>
      <span
        style={{
          fontSize: "small"
        }}
      >
        Import Source:
        {props.importSource != null &&
        props.importSource.indexOf("Google") > -1 ? (
          <i className="icon-tiny fa fa-google extra-color-1" />
        ) : null}
        {props.importSource != null &&
        props.importSource.indexOf("iCloud") > -1 ? (
          <i className="icon-tiny fa fa-apple extra-color-1" />
        ) : null}
        {props.importSource != null &&
        props.importSource.indexOf("Facebook") > -1 ? (
          <i className="icon-tiny fa fa-facebook extra-color-1" />
        ) : null}
        {props.importSource != null &&
        props.importSource.indexOf("LinkedIn") > -1 ? (
          <i className="icon-tiny fa fa-linkedin extra-color-1" />
        ) : null}
        {props.importSource != null &&
        props.importSource.indexOf("CSV") > -1 ? (
          <i className="icon-tiny fa fa fa-file-o extra-color-1" />
        ) : null}
      </span>
      {props.importSource != null &&
      props.importSource.indexOf("PRISM") > -1 ? (
        <strong>
          <span
            style={{
              color: "#a3a3a3",
              fontSize: "small"
            }}
          >
            PRISM
          </span>
        </strong>
      ) : null}
    </div>
  );
};

export const DividerWrapSmall = () => {
  return (
    <div className="divider-wrap" data-alignment="default">
      <div
        style={{
          marginTop: "12px",
          width: "20%px",
          height: "1px",
          marginBottom: "12px"
        }}
        data-width="20%"
        data-animate=""
        data-animation-delay=""
        data-color="extra-color-1"
        className="divider-small-border"
      />
    </div>
  );
};

export const DividerWrap = () => {
  return (
    <div className="divider-wrap" data-alignment="default">
      <div
        style={{
          marginTop: "12px",
          width: "100%",
          height: "1px",
          marginBottom: "12px"
        }}
        data-width="100%"
        data-animate=""
        data-animation-delay=""
        data-color="default"
        className="divider-border"
      />
    </div>
  );
};

export const AddNoteDialog = props => {
  const [note, setNote] = useState("");
  return (
    <Dialog
      open={props.open}
      onClose={() => props.setOpen(false)}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle>Add Note</DialogTitle>
      <DialogContent dividers>
        <textarea value={note} onChange={e => setNote(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            setNote("");
            props.setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            props.setOpen(false);
            if (note !== "") {
              props.callback(note);
            }
            setNote("");
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const EditNoteDialog = props => {
  const [note, setNote] = useState(props.note);
  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={props.open}
      onClose={() => props.setOpen(false)}
    >
      <DialogTitle>Edit Note</DialogTitle>
      <DialogContent dividers>
        <textarea
          value={note.note}
          onChange={e => setNote({ ...note, note: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            props.setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            props.setOpen(false);
            if (note !== "") {
              props.callback(note.id, note.note);
            }
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const Note = props => {
  const [edit, setEdit] = useState(false);

  return props.note != null ? (
    <div className="wpb_text_column wpb_content_element ">
      <div className="wpb_wrapper" style={{ display: "flex" }}>
        <div style={{ flex: 8 }}>
          <p style={{ padding: "5px" }}>
            {props.note.note.split("\n").map((item, key) => {
              return (
                <span key={key}>
                  {item}
                  <br />
                </span>
              );
            })}
          </p>
          <p
            style={{
              textAlign: "right",
              fontSize: "small"
            }}
          >
            {props.note.stageId > -1
              ? networkingSeries[0].stages[props.note.stageId].name + ","
              : null}{" "}
            {props.note.lastUpdated}
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <i
            className="icon-tiny fa fa-pencil extra-color-3 clickable"
            style={{ color: "#a3a3a3" }}
            onClick={() => setEdit(true)}
          />
          <i
            className="icon-tiny fa fa-trash-o extra-color-3 clickable"
            style={{ color: "#a3a3a3" }}
            onClick={() => {
              if (
                window.confirm("Are you sure you want to delete this note?")
              ) {
                props.deleteCallback(props.note.id);
              }
            }}
          />
          <EditNoteDialog
            open={edit}
            setOpen={setEdit}
            note={props.note}
            callback={props.editCallback}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export const NotesWidget = ({
  contactId,
  wordpressId,
  notes,
  callback,
  stage,
  showStageOnly,
  showAddNotes,
  showSearchNotes,
  nonce
}) => {
  const [search, setSearch] = useState("");
  const [filteredNotes, setFilteredNotes] = useState([]);
  const [open, setOpen] = useState(false);

  const fetchNotes = async cid => {
    await fetch("/wp-json/prism/v1/notes/" + cid, {
      headers: { "X-WP-Nonce": nonce }
    })
      .then(response => response.json())
      .then(result => callback(result));
  };

  const createNote = async n => {
    await fetch("/wp-json/prism/v1/create-note/", {
      method: "post",
      headers: { "Content-Type": "application/json", "X-WP-Nonce": nonce },
      body: JSON.stringify({
        contactId: contactId,
        wordpressId: wordpressId,
        note: n,
        stageId: stage != null ? stage.id : null
      })
    })
      .then(response => response.json())
      .then(result => {
        callback(result);
      });
  };

  const updateNote = async (id, note) => {
    await fetch("/wp-json/prism/v1/update-note/", {
      method: "post",
      headers: { "Content-Type": "application/json", "X-WP-Nonce": nonce },
      body: JSON.stringify({
        id: id,
        contactId: contactId,
        note: note
      })
    })
      .then(response => response.json())
      .then(result => {
        callback(result);
      });
  };

  const deleteNote = async id => {
    await fetch("/wp-json/prism/v1/delete-note/", {
      method: "delete",
      headers: { "Content-Type": "application/json", "X-WP-Nonce": nonce },
      body: JSON.stringify({
        id: id,
        contactId: contactId
      })
    })
      .then(response => response.json())
      .then(result => {
        callback(result);
      });
  };

  useEffect(() => {
    fetchNotes(contactId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactId]);

  useEffect(() => {
    if (notes != null) {
      if (search !== "") {
        let n = notes.slice();
        const s = search.toLowerCase();
        n = n.filter(item => item.note.toLowerCase().indexOf(s) > -1);
        setFilteredNotes(n);
      } else {
        setFilteredNotes(notes.slice());
      }
    }
  }, [search, notes]);

  function sortNotes(a, b) {
    let r = 0;
    r = a < b ? 1 : -1;
    return r;
  }
  return (
    <div>
      {showAddNotes != null && showAddNotes ? (
        <div
          className="wpb_wrapper"
          style={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <h3>
            Notes
            <i
              className="icon-tiny fa fa-plus extra-color-2 clickable"
              onClick={() => setOpen(true)}
            />
          </h3>
          <AddNoteDialog open={open} setOpen={setOpen} callback={createNote} />
        </div>
      ) : null}
      {showSearchNotes != null && showSearchNotes ? (
        <div
          style={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <i className="icon-tiny iconsmind-Magnifi-Glass22 extra-color-2" />
          <input
            key="searchNotes"
            type="text"
            onChange={e => setSearch(e.target.value)}
            value={search}
            placeholder="Search Notes"
            style={{ padding: "5px" }}
            className="prism"
          />
          <i
            className="icon-tiny fa fa-sort-numeric-asc extra-color-3 clickable"
            onClick={() =>
              setFilteredNotes(prev =>
                prev
                  .slice()
                  .sort((a, b) => sortNotes(a.lastUpdated, b.lastUpdated))
              )
            }
          />
          <i
            className="icon-tiny fa fa-sort-numeric-desc extra-color-3 clickable"
            onClick={() =>
              setFilteredNotes(prev =>
                prev
                  .slice()
                  .sort((a, b) => sortNotes(b.lastUpdated, a.lastUpdated))
              )
            }
          />
        </div>
      ) : null}

      {showStageOnly != null && showStageOnly && stage != null
        ? filteredNotes.map(n =>
            parseInt(n.stageId, 10) === parseInt(stage.id, 10) ? (
              <div>
                <DividerWrapSmall />
                <Note
                  note={n}
                  deleteCallback={deleteNote}
                  editCallback={updateNote}
                />
              </div>
            ) : null
          )
        : filteredNotes.map(n => (
            <div>
              <DividerWrapSmall />
              <Note
                note={n}
                deleteCallback={deleteNote}
                editCallback={updateNote}
              />
            </div>
          ))}
    </div>
  );
};

export const SalientCheckbox = withStyles({
  root: {
    "&$checked": {
      color: "#1e83ec"
    }
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />);

const CategoryCheckbox = ({ contacts, category, selected, callback }) => {
  const defaultChecked = contacts.every(c => {
    return c.categories != null && c.categories.match(new RegExp("(?:^|, )"+category.name+"(?:, |$)"))
    // && c.categories.indexOf(category.name) > -1;
    // && c.categories.split(', ').indexOf(category.name) > -1
  });

  const indeterminate =
    contacts.some(
      c => c.categories != null && c.categories.match(new RegExp("(?:^|, )"+category.name+"(?:, |$)"))
      // && c.categories.indexOf(category.name) > -1
      // && c.categories.split(', ').indexOf(category.name) > -1
    ) && !defaultChecked;

  useEffect(() => {
    callback(s => {
      return {
        ...s,
        [category.id]: defaultChecked ? 1 : indeterminate ? 0 : -1
      };
    });
  }, [callback, category, indeterminate, defaultChecked, contacts]);

  const me = () => {
    return selected != null && selected[category.id] != null
      ? selected[category.id]
      : null;
  };
  return (
    <SalientCheckbox
      color="primary"
      checked={me() === 1}
      onChange={() => {
        callback(s => {
          if (me() === 0 && indeterminate) {
            return { ...s, [category.id]: -1 };
          }
          if (me() === 1 && indeterminate) {
            return { ...s, [category.id]: 0 };
          }
          if (me() === -1 && indeterminate) {
            return { ...s, [category.id]: 1 };
          }
          if (me() === 1) {
            return { ...s, [category.id]: -1 };
          }
          if (me() === -1) {
            return { ...s, [category.id]: 1 };
          }
        });
      }}
      indeterminate={me() === 0}
    />
  );
};

export const ManageCategoriesWidget = ({
  contacts,
  contactsCallback,
  wordpressId,
  nonce
}) => {
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState(null);
  const [newCategory, setNewCategory] = useState("");
  const theme = createSalientTheme();

  const addCategory = async () => {
    if (newCategory !== "") {
      const flag = categories.some(r=>r.name === newCategory);
      if(flag == false){
      fetch("/wp-json/prism/v1/add-category/", {
        method: "post",
        headers: { "Content-Type": "application/json", "X-WP-Nonce": nonce },
        body: JSON.stringify({ name: newCategory, wordpressId: wordpressId })
      })
        .then(response => response.json())
        .then(result => {
          setNewCategory("");
          setCategories(result);
        });
      }
      else
      {
        alert("Category already exist");
      }
    }
  };

  const applyCategories = () => {
    fetch("/wp-json/prism/v1/apply-categories/", {
      method: "post",
      headers: { "Content-Type": "application/json", "X-WP-Nonce": nonce },
      body: JSON.stringify({
        categories: selected,
        contacts:
          contacts != null && contacts.length > 0
            ? contacts.map(c => c.id)
            : null,
        wordpressId: wordpressId
      })
    })
      .then(response => response.json())
      .then(result => contactsCallback(result));
  };

  useEffect(() => {
    if (wordpressId != null && nonce != null) {
      fetch("/wp-json/prism/v1/categories/" + wordpressId, {
        headers: { "X-WP-Nonce": nonce }
      })
        .then(response => response.json())
        .then(result => setCategories(result));
    }
  }, [wordpressId, nonce]);

  return (
    <ThemeProvider theme={theme}>
      <i
        className="icon-tiny fa fa-tag extra-color-3 clickable"
        onClick={() => setOpen(true)}
      />
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={() => {
          setOpen(false);
          setSelected([]);
          setNewCategory("");
        }}
        style={{ zIndex: 26000 }}
      >
        <DialogTitle>Manage Categories</DialogTitle>
        <DialogContent dividers>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <div style={{ flex: 4 }}>
              <input
                type="text"
                value={newCategory}
                placeholder="Add New Category"
                onChange={e => setNewCategory(e.target.value)}
              />
            </div>
            <div style={{ flex: 1, textAlign: "center" }}>
              <Button variant="outlined" onClick={() => addCategory()}>
                Save
              </Button>
            </div>
          </div>
          <div className="manageCategoriesWidget">
            {categories != null && contacts != null
              ? categories.map(c => {
                  return (
                    <div key={"category" + c.id}>
                      <CategoryCheckbox
                        contacts={contacts}
                        category={c}
                        selected={selected}
                        callback={setSelected}
                      />
                      {c.name}
                    </div>
                  );
                })
              : null}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              setOpen(false);
              setSelected([]);
              setNewCategory("");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              applyCategories();
              setOpen(false);
            }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export const createSalientTheme = () => {
  return createMuiTheme({
    typography: {
      htmlFontSize: 16,
      fontWeight: 300,
      fontFamily: "'Roboto','Latin'",

      h1: {
        fontFamily: "'Lato','Latin'",
        fontWeight: 700,
        fontSize: 60,
        lineHeight: "74px"
      },
      h2: {
        fontFamily: "'Lato','Latin'",
        fontWeight: 700,
        fontSize: 48,
        lineHeight: "58px"
      },
      h3: {
        fontFamily: "'Lato','Latin'",
        fontWeight: 400,
        fontSize: 26,
        lineHeight: "36px"
      },
      h4: {
        fontFamily: "'Lato','Latin'",
        fontWeight: 700,
        fontSize: 20,
        lineHeight: "26px"
      },
      h5: {
        fontFamily: "'Lato','Latin'",
        fontWeight: 700,
        fontSize: 14,
        lineHeight: "25px"
      },
      h6: {
        fontFamily: "'Lato','Latin'",
        fontWeight: 700,
        fontSize: 18,
        lineHeight: "26px"
      },
      button: {
        fontSize: 12
      }
    },
    palette: {
      text: {
        primary: "#333333"
      }
    }
  });
};
